import React, {h, Component} from 'preact';

const sellSteps = {
    SELL_EXPECTED_LIST_DATE: 25,
    SELL_PRICE_RANGE: 40,
    SELL_HOME_TYPE: 50,
    SELL_CONTACT_FORM1: 70,
    SELL_CONTACT_FORM2: 90,
    SELL_CHAT: 100
};

const buySteps = {
    BUY_PRICE_RANGE: 25,
    BUY_HOME_TYPE: 40,
    BUY_PROCESS: 50,
    BUY_CREDIT_SCORE: 70,
    BUY_CONTACT_FORM: 90,
    BUY_CHAT: 100
};

// SELL_AND_BUY_ADDRESS_STEP is actually 2 steps in 1
const sellAndBuySteps = {
    SELL_AND_BUY_ADDRESS_STEP: 25,
    SELL_EXPECTED_LIST_DATE: 40,
    SELL_HOME_TYPE: 50,
    SELL_PRICE_RANGE: 75,
    SELL_AND_BUY_CONTACT_STEP: 90,
    SELL_CHAT: 100
};

const stepsWithoutProgress = ['SELL_OR_BUY', 'LOADING'];

export default class ProgressBar extends Component {
    state = {
        indicatorWidth: 0
    };

    constructor(props) {
        super(props);

        this.state.indicatorWidth = this.calculateIndicatorWidth();
    }

    componentDidUpdate(previousProps, previousState, previousContext) {
        const currentStep = this.props.currentStep;

        if (previousProps.currentStep != currentStep) {
            if (!stepsWithoutProgress.includes(currentStep)) {
                this.setState({
                    indicatorWidth: this.calculateIndicatorWidth()
                });
            }
        }
    }

    calculateIndicatorWidth() {
        let widthNum = 0;
        const {currentStep, alsoBuying, isBuyer, sellBuyLocationForm} = this.props;
        if (stepsWithoutProgress.includes(currentStep)) {
            return widthNum;
        }
        if (isBuyer) {
            widthNum = buySteps[currentStep];
        } else if (alsoBuying) {
            widthNum = sellAndBuySteps[currentStep];
            if (sellBuyLocationForm) {
                widthNum = 30;
            }
        } else {
            widthNum = sellSteps[currentStep];
        }
        return widthNum;
    }

    render() {
        if (this.state.indicatorWidth < 1) {
            return null;
        }

        return (
            <div className="flow-progress">
                <div className="flow-progress-indicator" style={`width: ${this.state.indicatorWidth}%`}>
                    {/* <div className="flow-progress-stat">{this.indicatorWidth}% done</div> */}
                </div>
            </div>
        );
    }
}
